export enum PageDataType {
  Boolean = 'bool',
  Date = 'datetime',
  Int = 'int',
  Select = 'select',
  String = 'string',
  Double = 'double',
  Object = 'object',

  // Custom Types
  ProgressValue = 'ProgressValue',
  FullName = 'FullName',
  LicenseGroupsEmails = 'LicenseGroupsEmails',
  ProjectTeams = 'ProjectTeams',
  ProjectLicenseUsers = 'ProjectLicenseUsers',
  ProjectLicenseUserHasAccess = 'ProjectLicenseUserHasAccess',
  TeamLicenseUsers = 'TeamLicenseUsers',
  ReviewersStatus = 'ReviewersStatus',
  ReviewersUser = 'ReviewersUser',
  SiteStyles = 'SiteStyles',
  ContentSecurityPolicy = 'ContentSecurityPolicy',
  ChecklistColumnStatus = 'ChecklistColumnStatus',
  Roles = 'Roles',
  InProgressStatus = 'InProgressStatus',
  DoneStatus = 'DoneStatus',
  UserStatuses = 'UserStatuses'
}
